/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from '@store/getters.constants';

const getters = {
  [storeGetters.getDepartment]: (state) => {
    return state.department;
  },
  [storeGetters.getDepartments]: (state) => {
    return state.departments;
  },
//   [storeGetters.getLicenseByid]: (state) => {
//     return state.license;
//   },
//   [storeGetters.getLicenseCount]: (state) => {
//     return state.licenseCount;
//   },
};
export default { ...getters };